import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const issuesPinDataSlice = createSlice({
  name: "issuesPinData",
  initialState: {},
  reducers: {
    setIssuesPinData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => {
        if (curr && curr.id) {
          return { ...prev, [curr.id]: curr };
        }
        return prev;
      }, {}),
    mergeIssuesPinData: (state: any, action: PayloadAction<any>) => {
      state[action.payload.id] = { ...action.payload };
    },
    deleteIssuesPinData: (state: any, action: PayloadAction<any>) => {
      action.payload.forEach((issue: any) => {
        delete state[issue];
      });
    },
  },
});

export const { setIssuesPinData, mergeIssuesPinData, deleteIssuesPinData } = issuesPinDataSlice.actions;
export default issuesPinDataSlice.reducer;
